import { render } from "./CardGridComponent.vue?vue&type=template&id=727066f2"
import script from "./CardGridComponent.vue?vue&type=script&lang=js"
export * from "./CardGridComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__